import debounce from 'lodash/debounce';
import React, { FC } from 'react';
import { FieldWithValue } from 'api/tasks';
import { ProgressBar } from 'components/molecules/progress-bar';
import { useNumericInput } from 'hooks/use-input';

interface Props {
  field: FieldWithValue;
  initialValue?: number;
  onPressEnter?: () => void;
  onBlur?: () => void;
  onChange: (newValue, field) => void;
}

export const ProgressField: FC<Props> = (props) => {
  const { initialValue = Number(''), onChange, field } = props;

  const [value, , setValue] = useNumericInput(initialValue);
  const debouncedOnChange = debounce(
    (_value) => {
      onChange(_value, field);
    },
    250,
    { maxWait: 1000 },
  );

  return (
    <ProgressBar
      size="small"
      value={value}
      onChange={(v) => {
        setValue(v);
        debouncedOnChange(v);
      }}
    />
  );
};
